import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/qerko/qerko/frontend/link/src/app/loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Layout"] */ "/builds/qerko/qerko/frontend/link/src/components/layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/qerko/qerko/frontend/node_modules/@mui/material/Box/Box.js");
